/* 🤖 this file was generated by script */
export const wiconTrash01 = {
  name: 'trash_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 6v-.8c0-1.12 0-1.68-.22-2.1a2 2 0 00-.87-.88C14.48 2 13.92 2 12.8 2h-1.6c-1.12 0-1.68 0-2.1.22a2 2 0 00-.88.87C8 3.52 8 4.08 8 5.2V6m2 5.5v5m4-5v5M3 6h18m-2 0v11.2c0 1.68 0 2.52-.33 3.16a3 3 0 01-1.3 1.31c-.65.33-1.49.33-3.17.33H9.8c-1.68 0-2.52 0-3.16-.33a3 3 0 01-1.31-1.3C5 19.71 5 18.87 5 17.2V6"/></svg>`,
};
